import type { ReactElement } from 'react';
import { Menu, MenuItemLink } from 'react-admin';
import { isPlatformSession } from './apiClient.ts';
import {
  AccountTreeOutlined,
  AdminPanelSettingsOutlined,
  AssessmentOutlined,
  BusinessOutlined,
  DashboardOutlined,
  EventRepeatOutlined,
  FactoryOutlined,
  GroupsOutlined,
  PeopleOutlined,
  PersonSearchOutlined,
  PlaylistAddCheckOutlined,
  SettingsOutlined,
  TuneOutlined,
  WorkOutlined
} from '@mui/icons-material';

type NavigationItem = {
  label: string;
  to: string;
  icon: ReactElement;
};

// Icons for the nouns both products share match the restoration platform's.
const navigation: NavigationItem[] = [
  { label: 'Dashboard', to: '/', icon: <DashboardOutlined /> },
  { label: 'Reports', to: '/reports', icon: <AssessmentOutlined /> },
  { label: 'Contacts', to: '/contacts', icon: <PeopleOutlined /> },
  { label: 'Companies', to: '/companies', icon: <BusinessOutlined /> },
  { label: 'Renewals', to: '/renewals', icon: <EventRepeatOutlined /> },
  { label: 'Groups', to: '/groups', icon: <GroupsOutlined /> },
  {
    label: 'Group Suggestions',
    to: '/group-contact-suggestions',
    icon: <PlaylistAddCheckOutlined />
  },
  { label: 'Email Suggestions', to: '/contact-suggestions', icon: <PersonSearchOutlined /> },
  { label: 'Opportunities', to: '/opportunities', icon: <WorkOutlined /> },
  { label: 'Projects', to: '/projects', icon: <AccountTreeOutlined /> },
  { label: 'Programs', to: '/programs', icon: <TuneOutlined /> },
  { label: 'Industries', to: '/industry', icon: <FactoryOutlined /> },
  { label: 'Settings', to: '/settings', icon: <SettingsOutlined /> }
];

// Only for the addresses in PLATFORM_ADMIN_EMAILS, and not inside a support session.
const platform: NavigationItem = {
  label: 'Platform',
  to: '/platform',
  icon: <AdminPanelSettingsOutlined />
};

// Light on the navy drawer. MenuItemLink marks the current section with RaMenuItemLink-active.
const itemSx = {
  px: 2,
  py: 1.5,
  mb: 0.5,
  borderRadius: 1.5,
  fontSize: '1rem',
  color: 'rgba(255,255,255,.82)',
  '& .RaMenuItemLink-icon': { minWidth: 40, color: 'inherit' },
  '&:hover': { bgcolor: 'rgba(255,255,255,.08)' },
  '&.RaMenuItemLink-active': { bgcolor: 'rgba(255,255,255,.14)', color: '#fff' },
  '&.Mui-focusVisible': { outlineColor: '#fff', outlineOffset: -2 }
};

const CustomMenu = () => (
  <Menu sx={{ px: 1 }}>
    {(isPlatformSession() ? [...navigation, platform] : navigation).map((item) => (
      <MenuItemLink
        key={item.to}
        to={item.to}
        primaryText={item.label}
        leftIcon={item.icon}
        sx={itemSx}
      />
    ))}
  </Menu>
);

export default CustomMenu;
